import { render, staticRenderFns } from "./loyalty-reconciliation.vue?vue&type=template&id=32fd1f04&scoped=true"
import script from "./loyalty-reconciliation.vue?vue&type=script&lang=js"
export * from "./loyalty-reconciliation.vue?vue&type=script&lang=js"
import style0 from "./loyalty-reconciliation.vue?vue&type=style&index=0&id=32fd1f04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fd1f04",
  null
  
)

export default component.exports